import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getFileLaborContractSuccess,
  getFileLaborContractFailed,
  getFileLaborContractStart,
} from "../redux/getFileLaborContract";
import { getFileLaborContractApi } from "core/http/service/operationProcess";
import { handleFileDownload } from "helper/file";

function* getFileLaborContractWork(action) {
  try {
    const res = yield call(getFileLaborContractApi, action.payload);
    yield put({
      type: getFileLaborContractSuccess.type,
      payload: res,
    });
    handleFileDownload(res.fileName, res.fileData);
  } catch (error: any) {
    yield put({
      type: getFileLaborContractFailed.type,
    });
  }
}
function* watchgetFileLaborContract() {
  yield takeLatest(getFileLaborContractStart.type, getFileLaborContractWork);
}

export default function* getFileLaborContractSaga() {
  yield all([watchgetFileLaborContract()]);
}
